// app/javascript/packs/stripe.js
import { Application } from "stimulus"
import StripePaymentController from "../controllers/stripe_payment_controller"

const application = Application.start()
application.register("stripe-payment", StripePaymentController)
